<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.2773 11.1934C16.6117 11.1937 17.6933 12.2759 17.6934 13.6104V15.2764C17.6934 16.6109 16.6118 17.6931 15.2773 17.6934H4.72168C3.38699 17.6934 2.30469 16.6111 2.30469 15.2764V13.6104C2.30475 12.2757 3.38703 11.1934 4.72168 11.1934H15.2773ZM4.72168 12.6934C4.21546 12.6934 3.80475 13.1041 3.80469 13.6104V15.2764C3.80469 15.7826 4.21542 16.1934 4.72168 16.1934H15.2773C15.7833 16.1931 16.1934 15.7824 16.1934 15.2764V13.6104C16.1933 13.1043 15.7833 12.6937 15.2773 12.6934H4.72168Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.2773 2.30469C16.6118 2.30499 17.6934 3.38718 17.6934 4.72168V6.3877C17.6933 7.72214 16.6117 8.80439 15.2773 8.80469H4.72168C3.38703 8.80469 2.30475 7.72233 2.30469 6.3877V4.72168C2.30469 3.38699 3.38699 2.30469 4.72168 2.30469H15.2773ZM4.72168 3.80469C4.21542 3.80469 3.80469 4.21542 3.80469 4.72168V6.3877C3.80475 6.8939 4.21546 7.30469 4.72168 7.30469H15.2773C15.7833 7.30439 16.1933 6.89372 16.1934 6.3877V4.72168C16.1934 4.2156 15.7833 3.80499 15.2773 3.80469H4.72168Z"
            fill="currentColor"
        />
    </svg>
</template>
